import { Injectable } from '@angular/core'

@Injectable()
export class CacheService {
    constructor() { }
    cache = new Map();
    save(options) {
        // Set default values for optionals
        options.expirationMins = options.expirationMins || 0

        // Set expiration date in miliseconds
        const expirationMS = options.expirationMins !== 0 ? options.expirationMins * 60 * 1000 : 0

        const record = {
            value: typeof options.data === 'string' ? options.data : JSON.stringify(options.data),
            expiration: expirationMS !== 0 ? new Date().getTime() + expirationMS : null,
            hasExpiration: expirationMS !== 0 ? true : false
        }

        //sessionStorage.setItem(options.key, JSON.stringify(record));
        this.cache.set(options.key, JSON.stringify(record));
    }

    load(key: string) {
        // Get cached data from cache Map
        const item = this.cache.get(key)// sessionStorage.getItem(key)
        if (item) {
            const record = JSON.parse(item)
            const now = new Date().getTime()
            // Expired data will return null
            if (!record || (record.hasExpiration && record.expiration <= now)) {
                return null
            } else {
                return JSON.parse(record.value)
            }
        }
        return null
    }

    remove(key: string) {
        sessionStorage.removeItem(key)
    }

    cleanLocalStorage() {
        sessionStorage.clear()
    }
}

export class LocalStorageSaveOptions {
    key: string
    data: any
    expirationMins?: number
}